module.exports = __webpack_public_path__ + "static/media/service-img-09.d73d0543.png";